import React from 'react';
import { Typography, Box, IconButton } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const Header = () => {
  // Retrieve data from local storage
  const companyName = localStorage.getItem('companyName') || 'Company Name';
  const fromDate = localStorage.getItem('fromDate') || 'From Date';
  const toDate = localStorage.getItem('toDate') || 'To Date';

  const handleBack = () => {
    window.history.back();
  };

  return (
    <header className="bg-white sticky top-0 z-30 px-6 py-4 border-b border-slate-200 flex justify-between items-center shadow-sm w-full">
      <Box className="flex items-start gap-3">
        {/* Back Button */}
        <IconButton
          onClick={handleBack}
          aria-label="Go back"
          size="small"
          className="mt-1"
        >
          <ArrowBackIcon />
        </IconButton>

        <Box>
          <Typography variant="h5" className="font-bold text-slate-800 tracking-tight">
            {companyName || 'Dashboard'}
          </Typography>
          <Box className="flex items-center gap-2 mt-1">
            <span className="w-2 h-2 rounded-full bg-emerald-500"></span>
            <Typography variant="body2" className="text-slate-500 font-medium">
              Period: {fromDate} - {toDate}
            </Typography>
          </Box>
        </Box>
      </Box>

      <Box className="flex items-center gap-4">
        {/* Future: Add User Profile or Notifications here */}
      </Box>
    </header>
  );
};

export default Header;
